import * as React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Rect width={40} height={40} rx={20} fill={designSystem.colors.neutral700} />
        <Rect
            x={0.5}
            y={0.5}
            width={39}
            height={39}
            rx={19.5}
            stroke={ds.colorValue.icon.primary}
            strokeOpacity={0.03}
        />
        <Path
            d="M12.72 23.964C12.72 23.5875 12.9108 23.2387 13.2489 23.0732C14.2297 22.5934 16.5495 21.6802 20 21.6802C23.4505 21.6802 25.7703 22.5934 26.751 23.0732C27.0892 23.2387 27.28 23.5875 27.28 23.964C27.28 26.414 25.2938 28.4002 22.8438 28.4002H17.1562C14.7061 28.4002 12.72 26.414 12.72 23.964Z"
            fill={props.color ?? ds.colorValue.icon.secondary}
        />
        <Path
            d="M26.751 23.0732L26.3665 23.8592V23.8592L26.751 23.0732ZM13.2489 23.0732L12.8644 22.2873L12.8644 22.2873L13.2489 23.0732ZM22.8438 28.4002V27.5252H17.1562V28.4002V29.2752H22.8438V28.4002ZM13.2489 23.0732L13.6335 23.8592C14.5187 23.4261 16.7073 22.5552 20 22.5552V21.6802V20.8052C16.3917 20.8052 13.9407 21.7607 12.8644 22.2873L13.2489 23.0732ZM20 21.6802V22.5552C23.2926 22.5552 25.4813 23.4261 26.3665 23.8592L26.751 23.0732L27.1356 22.2873C26.0592 21.7607 23.6083 20.8052 20 20.8052V21.6802ZM17.1562 28.4002V27.5252C15.1894 27.5252 13.595 25.9308 13.595 23.964H12.72H11.845C11.845 26.8973 14.2229 29.2752 17.1562 29.2752V28.4002ZM27.28 23.964H26.405C26.405 25.9308 24.8106 27.5252 22.8438 27.5252V28.4002V29.2752C25.7771 29.2752 28.155 26.8973 28.155 23.964H27.28ZM27.28 23.964H28.155C28.155 23.2983 27.8122 22.6183 27.1356 22.2873L26.751 23.0732L26.3665 23.8592C26.372 23.8619 26.3781 23.8659 26.3856 23.8788C26.3944 23.8939 26.405 23.9225 26.405 23.964H27.28ZM12.72 23.964H13.595C13.595 23.9225 13.6056 23.8939 13.6143 23.8788C13.6219 23.8659 13.628 23.8619 13.6335 23.8592L13.2489 23.0732L12.8644 22.2873C12.1877 22.6183 11.845 23.2983 11.845 23.964H12.72Z"
            fill={props.color ?? ds.colorValue.icon.secondary}
        />
        <Path
            d="M23.3 14.9001C23.3 16.7226 21.8225 18.2001 20 18.2001C18.1774 18.2001 16.7 16.7226 16.7 14.9001C16.7 13.0776 18.1774 11.6001 20 11.6001C21.8225 11.6001 23.3 13.0776 23.3 14.9001Z"
            fill={props.color ?? ds.colorValue.icon.secondary}
            stroke={props.color ?? ds.colorValue.icon.secondary}
            strokeWidth={1.75}
        />
    </Svg>
);

export { SvgComponent as UserAvatarIcon };
